export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a0d6520b41be0124ac6f87414f7bd2a4.jpg"
          alt="Auto Transport Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          <div className="flex flex-wrap gap-3 mb-8">
            <span className="inline-flex items-center bg-white/95 text-gray-800 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
              <i className="ri-shield-check-line text-green-600 mr-2"></i>
              Licensed & Insured
            </span>
            <span className="inline-flex items-center bg-white/95 text-gray-800 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
              <i className="ri-star-fill text-yellow-500 mr-2"></i>
              BBB A+ Rated
            </span>
            <span className="inline-flex items-center bg-white/95 text-gray-800 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
              <i className="ri-time-line text-blue-600 mr-2"></i>
              10+ Years Experience
            </span>
          </div>

          <h1 className="text-7xl font-bold text-white mb-6 leading-tight">
            Ship Your Vehicle
            <br />
            <span className="text-orange-500">Anywhere</span> in the US
          </h1>

          <p className="text-2xl text-gray-200 mb-10 leading-relaxed">
            Get instant quotes from verified carriers. Safe, fast, and affordable auto transport.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#quote"
              className="inline-flex items-center bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="tel:3058719862"
              className="inline-flex items-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (305) 871-9862
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
